import {
  CREATE_EMP ,
  ALL_EMP ,
  ADMIN_UPDATE_EMP ,
  ERROR,
  All_Const
} from "../type";
const inital = {
  createEmp: [],
  getAllEmp: [],
  getAllEmpConst: [],
  updateAdmiEmp: [],
  error:[],
  loading: true,
};
const ManageEmpReduser = (state = inital, action) => {
  switch (action.type) {
    case CREATE_EMP:
      return {
        getAllEmp:state.getAllEmp,
        createEmp: action.payload,
      };
    case ADMIN_UPDATE_EMP:
      return {
        getAllEmp:state.getAllEmp,
        updateAdmiEmp: action.payload,
      };
      // case ADMIN_ONE_EMP:
      //   return {
      //     getAllEmp:state.getAllEmp,
      //     oneAdmiEmp: action.payload,
      //   };
    case ALL_EMP:
      return {
        ...state,
        getAllEmp: action.payload,
      };
      case All_Const:
        return {
          ...state,
          getAllEmpConst: action.payload,
        };
      case ERROR:
        return {
          getAllEmp:state.getAllEmp,
          loading: false,
          error: action.payload,
          // getAllEmp: action.payload,
        };
    default:
      return state;
  }
};
export default ManageEmpReduser;
